import 'swiper/css';

import Image from 'next/future/image';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Scrollbar } from 'swiper';
import LinkTo from '@/components/LinkTo';

const MaterialCards = () => {
  const { t } = useTranslation();

  const compMat = [
    {
      title: t('MAT_COMPONENT.KAPOK.TITLE'),
      description: t('MAT_COMPONENT.KAPOK.DESC'),
      link: '/kapok',
      src: '/v2/materials/innernav/kapok.jpg'
    },
    {
      title: t('MAT_COMPONENT.FLEXYCORN.TITLE'),
      description: t('MAT_COMPONENT.FLEXYCORN.DESC'),
      link: '/flexycorn',
      src: '/v2/materials/innernav/flexycorn.jpg'
    },
    {
      title: t('MAT_COMPONENT.ECOLYPT.TITLE'),
      description: t('MAT_COMPONENT.ECOLYPT.DESC'),
      link: '/ecolypt',
      src: '/v2/materials/innernav/ecolypt.jpg'
    },
    {
      title: t('MAT_COMPONENT.BIOLIGHT.TITLE'),
      description: t('MAT_COMPONENT.BIOLIGHT.DESC'),
      link: '/biolight',
      src: '/v2/materials/innernav/biolight.jpg'
    },
    {
      title: t('MAT_COMPONENT.NATEX.TITLE'),
      description: t('MAT_COMPONENT.NATEX.DESC'),
      link: '/natex',
      src: '/v2/materials/innernav/natex.jpg'
    },
    {
      title: t('MAT_COMPONENT.COOLTH_SL.TITLE'),
      description: t('MAT_COMPONENT.COOLTH_SL.DESC'),
      link: '/coolthsl',
      src: '/v2/materials/innernav/cool.jpg'
    }
  ];

  return (
    <div className="grid gap-8 grid-cols-12 mt-10 md:mt-0">
      <div className="col-span-12">
        <LinkTo href="/materials" className="flex items-center space-x-4">
          <div className="inline-flex border text-center uppercase space-x-1 bg-white text-black p-2.5 rounded-full md:p-4 cursor-pointer h-max">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
              />
            </svg>
          </div>
          <span className="h5">{t('MAT_COMPONENT.BTN')}</span>
        </LinkTo>
      </div>

      <div className="col-span-12">
        <Swiper
          wrapperTag="ul"
          slidesPerView={1.2}
          spaceBetween={16}
          navigation={true}
          modules={[Scrollbar, Navigation]}
          scrollbar={{ hide: false }}
          className="swiper swiperScrollbar overflow-visible"
          breakpoints={{
            768: {
              slidesPerView: 2.2
            },
            1024: {
              slidesPerView: 3.2
            }
          }}
        >
          {compMat.map((card, idx) => (
            <SwiperSlide
              key={idx}
              tag="li"
              className="group rounded-uyn relative md:aspect-landscape aspect-card text-white flex items-center overflow-hidden justify-center"
            >
              <Image
                src={card.src}
                alt=""
                width={0}
                height={0}
                sizes="100vw"
                className="w-full absolute top-0 left-0 h-full object-center object-cover z-10"
              />

              <div className="flex-col space-y-2 md:p-6 p-4 flex items-center justify-center relative z-20 text-center">
                <div className="h5">{card.title}</div>
                <div className="text-body max-w-[500px] mx-auto">
                  {card.description}
                </div>
              </div>
              <div className="absolute z-30 group-hover:bg-black/20 transition-all duration-200 left-0 top-0 w-full h-full"></div>

              <LinkTo
                className="absolute w-full h-full top-0 left-0 z-40"
                href={card.link}
              ></LinkTo>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default MaterialCards;
